import React from 'react';
import { Barcode, Info, SearchSlash } from 'lucide-react';
import DirhamIcon from '../../assets/Currency/DirhamIcon';

const ModernNoImageGrid = ({
    filteredItems,
    setLastInteractedItem,
    handleAddToBill,
    handleOutOfStockAlert,
    showStockBreakdown,
    handleFindNearestStock,
    activeCardIndex,
    setActiveCardIndex
}) => {
    return (
        <div className="so-grid-area">
            {filteredItems.length === 0 ? (
                <div className="col-span-full h-96 flex flex-col items-center justify-center text-slate-300 gap-4 opacity-70">
                    <SearchSlash size={64} strokeWidth={1} />
                    <span className="font-black text-sm uppercase tracking-[0.2em]">No products found</span>
                </div>
            ) : (
                filteredItems.map((item, index) => (
                    <div
                        key={item.id}
                        className={`so-item-card no-image relative ${activeCardIndex === index ? 'focused-card' : ''}`}
                        onClick={() => {
                            if (setActiveCardIndex) setActiveCardIndex(index);
                            setLastInteractedItem(item);
                            handleAddToBill(item);
                        }}
                    >
                        {/* Top Row: Barcode & Focused Indicator */}
                        <div className="flex items-center justify-between w-full" style={{ height: '16px' }}>
                            {((item.barcodes && item.barcodes.length > 0) || item.barcode || item.id) ? (
                                <span className="text-slate-500 font-bold font-mono flex items-center gap-1 text-[9.5px]" style={{ letterSpacing: '0.02em' }}>
                                    <Barcode size={11} className="opacity-70 text-slate-500" /> {item.barcodes?.[0]?.barcode || item.barcode || item.id}
                                </span>
                            ) : (
                                <span className="text-slate-300 font-bold flex items-center gap-1 text-[9px]">
                                    <Barcode size={10} className="opacity-20" /> -
                                </span>
                            )}
                            {activeCardIndex === index && (
                                <div className="bg-amber-500 text-white text-[8px] font-extrabold px-1 rounded shadow-sm uppercase tracking-wider animate-pulse flex items-center gap-0.5" style={{ height: '14px', lineHeight: '14px' }}>
                                    <span className="bg-amber-600 px-0.5 rounded text-[7px]">ENTER</span> ADD
                                </div>
                            )}
                        </div>

                        {/* Item Name */}
                        <h4 className="so-item-name flex-1 mt-1 text-[12px] font-black uppercase text-slate-800 tracking-tight" style={{ minHeight: 'auto', lineClamp: 2, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', lineHeight: '1.25' }}>
                            {item.name}
                        </h4>

                        {/* Bottom Row: Price & Info Button */}
                        <div className="flex items-center justify-between pt-1.5 border-t border-slate-100 mt-auto">
                            <div className="flex flex-col">
                                <span className="text-[8px] font-bold text-slate-400 uppercase leading-none mb-0.5">Price</span>
                                <span className="font-black text-slate-900 text-[12px] flex items-center gap-0.5">
                                    <DirhamIcon size={10} className="text-slate-500" /> {parseFloat(item.price).toFixed(2)}
                                </span>
                            </div>

                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    showStockBreakdown(item);
                                }}
                                className="w-6 h-6 flex items-center justify-center rounded-md bg-slate-50 text-slate-400 hover:bg-slate-900 hover:text-white transition-all border border-slate-200 cursor-pointer"
                                title="Item Details"
                            >
                                <Info size={12} />
                            </button>
                        </div>

                        <div style={{ height: '22px', display: 'flex', alignItems: 'center', marginTop: '4px', flexShrink: 0 }}>
                            {item.local_qty <= 0 ? (
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleFindNearestStock(item);
                                    }}
                                    className="w-full py-1 bg-slate-50 text-slate-500 rounded-md border border-slate-200 text-[8.5px] font-bold uppercase tracking-tight hover:bg-slate-200 hover:text-slate-700 transition-all cursor-pointer"
                                >
                                    Request Stock
                                </button>
                            ) : (
                                <div className={`so-item-instock-placeholder ${item.local_qty <= 10 ? 'low-stock' : ''}`} style={{ padding: '0.15rem 0', fontSize: '9px', fontWeight: 800, letterSpacing: '0.03em' }}>
                                    {item.local_qty} UNITS
                                </div>
                            )}
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default ModernNoImageGrid;